module.exports = __webpack_public_path__ + "img/w22-b2.4ae6d5d0.jpg";